/* eslint-disable import/prefer-default-export */
export function validateEmail(email) {
  const regex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,254})$/i;
  const match = regex.exec(email);
  return match != null;
}
